import { ApolloCache, Reference } from '@apollo/client'

export const updatePaymentOptionsInApolloCache = <
    T extends { id: string | null },
>(
    cache: ApolloCache<any>,
    userId: number,
    cardsToKeep: (T | null)[],
) => {
    cache.modify({
        id: cache.identify({ __typename: 'User', id: userId }),
        fields: {
            paymentOptions(existingPaymentOptions, { readField }) {
                return existingPaymentOptions.filter(
                    (existingCard: Reference) =>
                        cardsToKeep.find(
                            card => card?.id === readField('id', existingCard),
                        ),
                )
            },
        },
    })
}
